
import { supabase } from "@/integrations/supabase/client";
import { ContentItem } from "@/components/dashboard/content-card/types";

/**
 * Utility function to fetch all content items (excluding the current one)
 * with increased limit for network visualization
 */
export const fetchAllRelatedContent = async (userId: string, currentContentId: string) => {
  console.log(`[NETWORK DEBUG] Fetching all related content for user ${userId} excluding ${currentContentId}`);
  
  const { data, error } = await supabase
    .from("content_items")
    .select("*")
    .eq("user_id", userId)
    .eq("archived", false)
    .neq("id", currentContentId)
    .order("created_at", { ascending: false })
    .limit(350);

  if (error) {
    console.error("Error fetching all related content:", error);
    return [];
  }

  console.log(`[NETWORK DEBUG] All related content fetched: ${data?.length || 0} items`);
  return data as ContentItem[];
};
